import { Switch, Route, Redirect, useRouteMatch } from 'peach/router'

import CreditAgencies from './CreditAgencies'
import CreditAgency from './CreditAgency'
import CreateCreditAgency from './CreateCreditAgency'
import GenerateCreditReport from './GenerateCreditReport'

const CreditAgenciesRoutes = () => {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <CreditAgencies />
      </Route>

      <Route path={`${path}/create`}>
        <CreateCreditAgency />
      </Route>

      <Route path={`${path}/generate-credit-report`}>
        <GenerateCreditReport />
      </Route>

      <Route path={`${path}/:creditAgencyId`}>
        <CreditAgency />
      </Route>

      <Redirect to={url} />
    </Switch>
  )
}

export default CreditAgenciesRoutes
